import React, { useContext, useEffect } from 'react'
import { useSelector } from 'react-redux'; // useSelector & useDispatch can only be used in functional component

import { AsideContext } from '../TheAside';
import { roundTo2DecimalPlaces } from '../../../../utils';
import { useIsLatestPlan } from '../../../../helpers/customHooks';
import LegacyPlanRecommendation from './LegacyPlanRecommendation';

const UpgradeReporting = () => {
     const { setPackageSelected } = useContext(AsideContext);
     const packages = useSelector(state => state.subscriber.packages);
     const packageReport = packages.find(packageItem => packageItem.eventReporting);
     const isLatestPlan = useIsLatestPlan();

     useEffect(() => {
          setPackageSelected(packageReport);
     }, [setPackageSelected, packageReport])

     return (
          <>
               <div className="description">
                    <p className="text-center fw-4">
                         Upgrade your account to gain access to detailed event & data layer variable reporting.{" "}
                         Build reports for specific listeners and view data and charts from your website activity over time.
                    </p>
               </div>
               <div className="sidebar-body">
                    <h6 className="text-success text-center recommendation">Recommendation</h6>
                    {
                         isLatestPlan ? (
                              <p className="text-center recommendation-text fw-4">
                                   Upgrade to the {packageReport.friendlyName} plan for ${roundTo2DecimalPlaces(packageReport.pricePerYear / 12).toLocaleString('en-US')}/month
                                   (paid annually) and gain access to data layer event reporting, along with other great features!
                              </p>
                         ) : <LegacyPlanRecommendation />
                    }
               </div>
          </>
     )
}

export default UpgradeReporting;